import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { mode } from "services/codes";
import { PageableResponse } from "../PageableResponse";

export type B000224FindRequest = Partial<{
  batchNo: string;
  haisorouteNoFrom: string;
  haisorouteNoTo: string;
  name: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000224FindResponse = {
  haisorouteNo: string;
  haisorouteNm: string;
  batchNo: string;
  version: string;
};

export const B000224Find = (props: B000224FindRequest) => {
  return RestClient.get<PageableResponse<B000224FindResponse[]>>(
    "b000224/find",
    {
      params: props,
    }
  );
};

export type B000224GetRequest = {
  haisorouteNo: string;
};

export const B000224Get = (props: B000224GetRequest) => {
  return RestClient.get("b000224/get", {
    params: props,
  });
};

//配送ルート名表示
export const B000224HaisorouteNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.haisorouteNo === "") {
    methods.setValue("haisorouteNm", data.haisorouteNo);
    return;
  }
  await B000224Get({ haisorouteNo: data.haisorouteNo })
    .then((response) => {
      methods.setValue("haisorouteNm", response.data.haisorouteNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("haisorouteNm", "");
    });
};

//配送ルート名表示 B100220 配送ルート割付マスタメンテでつかう
export const B000224HaisorouteNmByHeaderHaisorouteNo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.headerHaisorouteNo === "") {
    methods.setValue("haisorouteNm", data.haisorouteNo);
    return;
  }
  await B000224Get({ haisorouteNo: data.headerHaisorouteNo })
    .then((response) => {
      methods.setValue("haisorouteNm", response.data.haisorouteNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("haisorouteNm", "");
    });
};

// 配送ルート名関連項目表示 B100230 配送ルートバッチマスタメンテでつかう
export const B100230HaisorouteUsedByB100224 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();

  if (typeof fields.haisorouteNoBefore !== "undefined") {
    if (fields.haisorouteNoBefore === fields.haisorouteNo) {
      return;
    } else {
      methods.setValue("haisorouteNoBefore", fields.haisorouteNo);
    }
  }

  if (fields.haisorouteNo === "") {
    methods.setValue("haisorouteNm", "");
    methods.setValue("version", "");
    methods.setValue("batchNo", "");
    methods.setValue("batchNm", "");
    return;
  }
  // 配送ルート名表示
  await B000224Get({
    haisorouteNo: fields.haisorouteNo,
  })
    .then((response) => {
      // モードが新規の場合
      if (fields.modeKbn.value === mode.shinki) {
        return;
        // モードが修正の場合
      } else if (fields.modeKbn.value === mode.shusei) {
        methods.setValue("haisorouteNm", response.data.haisorouteNm ?? "");
        methods.setValue("version", response.data.version ?? "");
        methods.setValue("batchNo", response.data.batchNo ?? "");
        // モードが削除の場合
      } else if (fields.modeKbn.value === mode.sakujo) {
        methods.setValue("haisorouteNm", response.data.haisorouteNm ?? "");
        methods.setValue("version", response.data.version ?? "");
      }
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      catchRestError(reason, navigate, setMsg);
      methods.setValue("haisorouteNm", "");
      methods.setValue("version", "");
      methods.setValue("batchNo", "");
      methods.setValue("batchNm", "");
    });
};
